/** Convert v2 wire text blocks to existing flat editor tokens; media and eos stay untouched. */
export function flattenScoreWire(body: string): string {
  if (!body.includes('RECEPTION_SCORE_')) return body;
  return body.replace(/\{\{#text\}\}([\s\S]*?)\{\{\/text\}\}/g, (_, content: string) => {
    if (!content.includes('{{#concept}}')) return `{{#text}}${content}{{/text}}`;
    return content
      .split(/(\{\{#concept\}\}[\s\S]*?\{\{\/concept\}\})/g)
      .filter(Boolean)
      .map((part) => (part.startsWith('{{#concept}}') ? part : `{{#text}}${part}{{/text}}`))
      .join('');
  });
}
